import React from "react";
import { useStore } from "react-redux";
import CONFIG from "../../config";

export function MaxShipmentError() {
  const { configStorage, basketStorage } = useStore().getState();
  if (!basketStorage || !basketStorage.getMaxShipmentText || !configStorage || configStorage.isAnkaufShop()) return null;
  if (basketStorage.hasFilialChoice) {
    return (
      <div className="ser-textpanel ser-grey">
        {CONFIG.getShopConfig({
          edelmetall: "Bei Edelmetallen über",
          sorten: "Bei Währungen ab"
        })}
        {" "}<strong className="text-primary">{basketStorage.getMaxShipmentText()}</strong>{" "}
        EUR ist nur eine Abholung in Ihrer Bank möglich.
      </div>
    );
  }
  if(!basketStorage.sumLessthanMinOdervalueFiliale) { 
    return (
      <div
        className="ser-textpanel ser-grey">
        Bitte beachten Sie, dass nur die Bestellung
        bis zu einem Gegenwert von
        {" "}<strong className="text-primary">{basketStorage.getMaxBetragText()}</strong>{" "}
        Euro möglich ist.
      </div>
    );
  }
};

